"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemImage = void 0;
var _mui = require("@ori-ui/mui");
var _checkoutUi = require("@ori/checkout-ui");
var _constants = require("../constants");
var _context = require("../context");
var _jsxRuntime = require("react/jsx-runtime");
const ImageHolder = (0, _mui.styled)('span')(({
  ownerState: {
    isSmall
  },
  theme
}) => ({
  display: 'block',
  boxSizing: 'border-box',
  gridArea: 'image',
  width: _constants.XS_IMAGE_SIZE,
  height: _constants.XS_IMAGE_SIZE,
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  ...(!isSmall && {
    [theme.breakpoints.up('md')]: {
      width: _constants.MD_IMAGE_SIZE,
      height: _constants.MD_IMAGE_SIZE
    }
  })
}));
const ImageHolderLink = (0, _mui.styled)('a')(({
  ownerState: {
    isSmall
  },
  theme
}) => ({
  display: 'block',
  boxSizing: 'border-box',
  gridArea: 'image',
  width: _constants.XS_IMAGE_SIZE,
  height: _constants.XS_IMAGE_SIZE,
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  ...(!isSmall && {
    [theme.breakpoints.up('md')]: {
      width: _constants.MD_IMAGE_SIZE,
      height: _constants.MD_IMAGE_SIZE
    }
  })
}));
const ItemImage = () => {
  const {
    image,
    isAvailable,
    itemTestId,
    name,
    url,
    isSmall
  } = (0, _context.useItemContext)();
  const theme = (0, _mui.useTheme)();
  const testId = `${itemTestId}-image`;
  const theImage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutUi.CheckoutImage, {
    src: image ?? 'noImage',
    "data-testid": testId,
    alt: name,
    opacity: isAvailable ? 1 : 0.5,
    background: theme.palette.grey[100],
    size: isSmall ? 'basketItemSmall' : 'basketItem'
  });
  if (url === undefined) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ImageHolder, {
      "data-testid": `${testId}-wrapper`,
      ownerState: {
        isSmall: isSmall ?? false
      },
      children: theImage
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ImageHolderLink, {
    "data-testid": `${testId}-wrapper`,
    href: url,
    ownerState: {
      isSmall: isSmall ?? false
    },
    "aria-label": name,
    children: theImage
  });
};
exports.ItemImage = ItemImage;
